"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var Box_1 = __importDefault(require("@mui/material/Box"));
var LoginAlert_1 = require("@components/case/login/login/LoginAlert");
var LoginForm_1 = require("@components/case/login/login/LoginForm");
var PageTitle_1 = require("@components/case/login/PageTitle");
var login_1 = require("@domain/login");
var useBreakpoints_1 = require("@hooks/useBreakpoints");
/**
 * ログイン表示
 *
 * @return {*}
 */
var Index = function () {
    var isUnderXs = (0, useBreakpoints_1.useIsUnderXs)();
    return ((0, jsx_runtime_1.jsx)(Box_1.default, { sx: { minHeight: "100dvh", background: "#DBE6F0" }, children: (0, jsx_runtime_1.jsxs)(Box_1.default, { sx: { maxWidth: isUnderXs ? "100%" : "400px", margin: "0 auto" }, children: [(0, jsx_runtime_1.jsx)(PageTitle_1.PageTitle, { title: "\u30ED\u30B0\u30A4\u30F3" }), (0, jsx_runtime_1.jsxs)(Box_1.default, { sx: isUnderXs ? login_1.styleForSp : {}, children: [(0, jsx_runtime_1.jsx)(LoginAlert_1.LoginAlert, {}), (0, jsx_runtime_1.jsx)(LoginForm_1.LoginForm, {})] })] }) }));
};
// eslint-disable-next-line import/no-default-export -- 暫定対応
exports.default = Index;
